module.exports = __webpack_public_path__ + "assets/72af345e6cce783d546e7f196ff34f84.svg";